import { useMemo, useState } from 'react';
import {
  AppstoreOutlined,
  DashboardOutlined,
  LockOutlined,
  LogoutOutlined,
  ProfileOutlined,
  ShoppingOutlined,
  TagsOutlined,
} from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ResponsiveAppShell } from '@mall/shared';
import { useAuth } from '../features/auth/AuthProvider';
import { ChangePasswordModal } from '../features/auth/ChangePasswordModal';

const MENU_ITEMS = [
  { key: '/', icon: <DashboardOutlined />, label: '概览' },
  { key: '/products', icon: <ShoppingOutlined />, label: '商品' },
  { key: '/orders', icon: <ProfileOutlined />, label: '订单' },
  { key: '/brands', icon: <TagsOutlined />, label: '品牌' },
  { key: '/categories', icon: <AppstoreOutlined />, label: '分类' },
];

export function AdminShell() {
  const { session, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  const selectedKey = useMemo(() => {
    const match = MENU_ITEMS.find((item) =>
      item.key === '/' ? location.pathname === '/' : location.pathname.startsWith(item.key),
    );
    return match?.key ?? '/';
  }, [location.pathname]);

  return (
    <ResponsiveAppShell
      brand={{
        mark: 'M',
        title: '商户管理后台',
        subtitle: '商品、订单与门店运营',
      }}
      menuItems={MENU_ITEMS}
      selectedKey={selectedKey}
      onNavigate={(key) => navigate(key)}
      topbarTitle="商户工作台"
      topbarSubtitle="管理当前租户的商品、订单、品牌与分类"
      contextPill={
        <span className="mall-context-pill">
          租户 <b>#{session?.tenantId ?? '-'}</b>
          <span style={{ opacity: 0.42 }}>·</span>
          <span className="mall-context-host">{window.location.hostname}</span>
        </span>
      }
      userLabel={session?.username ?? '未登录'}
      userMenu={{
        items: [
          {
            key: 'password',
            icon: <LockOutlined />,
            label: '修改密码',
            onClick: () => setPasswordModalOpen(true),
          },
          {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: '退出登录',
            onClick: async () => {
              await logout();
              navigate('/login', { replace: true });
            },
          },
        ],
      }}
      extras={
        <ChangePasswordModal
          open={passwordModalOpen}
          onClose={() => setPasswordModalOpen(false)}
        />
      }
    >
      <Outlet />
    </ResponsiveAppShell>
  );
}
